import { createContext } from "reka-ui";
import type { ComputedRef, Ref } from "vue";

export type ValidationStatus = "error" | "none" | "success" | "warning";

interface FieldContext {
  inputId: string;
  descriptionId: string;
  hintId: string;
  validationMessageId: string;
  required: Ref<boolean>;
  disabled: Ref<boolean>;
  validationStatus: Ref<ValidationStatus | undefined>;
}

export const [injectFieldContext, provideFieldContext] =
  createContext<FieldContext>("Field");

interface RadioGroupContext {
  name: ComputedRef<string>;
  modelValue: Ref<unknown>;
  disabled: ComputedRef<boolean>;
  inputElements: Set<HTMLInputElement>;
}

export const [injectRadioGroupContext, provideRadioGroupContext] =
  createContext<RadioGroupContext>("RadioGroup");
